export default {
  definitions: [],
  getDefinition (string) {
    if (undefined !== this.definitions[string]) {
      return this.definitions[string]
    }
    return string
  }
}
